function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2.432 14.922a1.56 1.56 0 000 2.155l11.256 11.625a.962.962 0 001.392 0l.774-.8a1.04 1.04 0 000-1.437L7.221 17.55H29a1 1 0 001-1v-1.098a1 1 0 00-1-1H7.22l8.634-8.916a1.04 1.04 0 000-1.437l-.774-.8a.962.962 0 00-1.392 0L2.432 14.922z",
  fill: "currentColor"
})));